var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPasswordUpdated = function SvgIconPasswordUpdated(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 208 209"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 208,
    y: 0.5,
    rx: 104
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m95.995 117.184 36.77-36.77 5.656 5.657-42.426 42.426-25.456-25.455 5.657-5.657z"
  })));
};
export default SvgIconPasswordUpdated;